// Blog registry — import each blog's markdown and images here
// CRA requires explicit imports so webpack can bundle them

// ── Context before code / Cursor workflow ──
import contextBeforeCodeMd from './context-before-code/index.md'
import contextBeforeCodeCover from './context-before-code/images/cover.png'

const contextBeforeCodeImages = {
  './images/cover.png': contextBeforeCodeCover,
}

// ── Voice jitter buffer ──
import jitterBufferMd from './voice-jitter-buffer/index.md'
import jitterBufferCover from './voice-jitter-buffer/images/cover.jpeg'

const jitterBufferImages = {
  './images/cover.jpeg': jitterBufferCover,
}

// ── Agent concurrency: lost update vs write skew ──
import agentConcurrencyMd from './two-people-saved-the-same-agent/index.md'
import agentConcurrencyCover from './two-people-saved-the-same-agent/images/cover.jpeg'

const agentConcurrencyImages = {
  './images/cover.jpeg': agentConcurrencyCover,
}

// ── Outbound services / model gateway ──
import outboundMd from './outbound-services/index.md'
import outboundCover from './outbound-services/images/cover.jpeg'
import outboundArch from './outbound-services/images/architecture.svg'

const outboundImages = {
  './images/cover.jpeg': outboundCover,
  './images/architecture.svg': outboundArch,
}

// ── Trojan horse / zero trust ──
import trojanMd from './trojan-horse-inside/index.md'
import trojanCover from './trojan-horse-inside/images/cover.png'

const trojanImages = {
  './images/cover.png': trojanCover,
}

// ── Prompt → Loop Engineering Blog ──
import promptLoopMd from './prompt_to_loop_engineering/index.md'
import promptLoopCover from './prompt_to_loop_engineering/images/cover.png'
import promptLoop01 from './prompt_to_loop_engineering/images/01-evolution-layers.svg'
import promptLoop02 from './prompt_to_loop_engineering/images/02-chatbot-vs-agent.svg'
import promptLoop03 from './prompt_to_loop_engineering/images/03-context-window.svg'
import promptLoop04 from './prompt_to_loop_engineering/images/04-harness-workflow.svg'
import promptLoop05 from './prompt_to_loop_engineering/images/05-harness-blocks.svg'
import promptLoop06 from './prompt_to_loop_engineering/images/06-sandbox-guardrails.svg'
import promptLoop07 from './prompt_to_loop_engineering/images/07-react-loop.svg'
import promptLoop08 from './prompt_to_loop_engineering/images/08-loop-safeguards.svg'
import promptLoop09 from './prompt_to_loop_engineering/images/09-loop-vs-harness.svg'

const promptLoopImages = {
  './images/cover.png': promptLoopCover,
  './images/01-evolution-layers.svg': promptLoop01,
  './images/02-chatbot-vs-agent.svg': promptLoop02,
  './images/03-context-window.svg': promptLoop03,
  './images/04-harness-workflow.svg': promptLoop04,
  './images/05-harness-blocks.svg': promptLoop05,
  './images/06-sandbox-guardrails.svg': promptLoop06,
  './images/07-react-loop.svg': promptLoop07,
  './images/08-loop-safeguards.svg': promptLoop08,
  './images/09-loop-vs-harness.svg': promptLoop09,
}

// ── TwentyHQ Dynamic Schema Blog ──
import twentyMd from './dynamic-schema-generation-twenty/index.md'
import twentyCover from './dynamic-schema-generation-twenty/images/cover.png'
import twentyCoreDb from './dynamic-schema-generation-twenty/images/core-db-vs-workspace-db.svg'
import twentyQueryExec from './dynamic-schema-generation-twenty/images/query-execution.svg'
import twentyRuntimeSchema from './dynamic-schema-generation-twenty/images/runtime-schema-creation.svg'
import twentyTraditional from './dynamic-schema-generation-twenty/images/traditional-twenty-appraoch.svg'

const twentyImages = {
  './images/cover.png': twentyCover,
  './images/core-db-vs-workspace-db.svg': twentyCoreDb,
  './images/query-execution.svg': twentyQueryExec,
  './images/runtime-schema-creation.svg': twentyRuntimeSchema,
  './images/traditional-twenty-appraoch.svg': twentyTraditional,
}

// ── WebRTC Blog ──
import webrtcMd from './webrtc/index.md'
import img01 from './webrtc/images/01-websocket-flow.svg'
import img02 from './webrtc/images/02-websocket-scalability.svg'
import img03 from './webrtc/images/03-webrtc-direct.svg'
import img04 from './webrtc/images/04-nat-problem.svg'
import img05 from './webrtc/images/05-nat-translation.svg'
import img06 from './webrtc/images/06-stun-server.svg'
import img07 from './webrtc/images/07-turn-server.svg'
import img08 from './webrtc/images/08-signaling.svg'
import img09 from './webrtc/images/09-offer-answer.svg'
import img10 from './webrtc/images/10-connection-established.svg'
import img11 from './webrtc/images/11-data-channel.svg'
import img12 from './webrtc/images/12-multiple-p2p.svg'
import img13 from './webrtc/images/13-mcu-architecture.svg'
import img14 from './webrtc/images/14-sfu-architecture.svg'

const webrtcImages = {
  './images/01-websocket-flow.svg': img01,
  './images/02-websocket-scalability.svg': img02,
  './images/03-webrtc-direct.svg': img03,
  './images/04-nat-problem.svg': img04,
  './images/05-nat-translation.svg': img05,
  './images/06-stun-server.svg': img06,
  './images/07-turn-server.svg': img07,
  './images/08-signaling.svg': img08,
  './images/09-offer-answer.svg': img09,
  './images/10-connection-established.svg': img10,
  './images/11-data-channel.svg': img11,
  './images/12-multiple-p2p.svg': img12,
  './images/13-mcu-architecture.svg': img13,
  './images/14-sfu-architecture.svg': img14,
}

// ── MCP vs A2A Blog ──
import mcpMd from './mcp_vs_a2a/index.md'
import mcpCover from './mcp_vs_a2a/images/cover.svg'
import mcpExample from './mcp_vs_a2a/images/mcp-example.svg'
import mcpArch from './mcp_vs_a2a/images/mcp-architecture.svg'
import a2aExample from './mcp_vs_a2a/images/a2a-example.svg'
import a2aArch from './mcp_vs_a2a/images/a2a-architecture.svg'
import decisionFlow from './mcp_vs_a2a/images/decision-flow.svg'
import comparison from './mcp_vs_a2a/images/comparison.svg'
import agenticMesh from './mcp_vs_a2a/images/agentic-mesh.svg'

const mcpImages = {
  './images/cover.svg': mcpCover,
  './images/mcp-example.svg': mcpExample,
  './images/mcp-architecture.svg': mcpArch,
  './images/a2a-example.svg': a2aExample,
  './images/a2a-architecture.svg': a2aArch,
  './images/decision-flow.svg': decisionFlow,
  './images/comparison.svg': comparison,
  './images/agentic-mesh.svg': agenticMesh,
}

// ── Generative UI Blog ──
import genUiMd from './generative_ui/index.md'
import genHero from './generative_ui/images/hero-image.svg'
import genArch from './generative_ui/images/architecture-flow.svg'
import genTransform from './generative_ui/images/data-transformation.svg'
import genStack from './generative_ui/images/tech-stack.svg'

const genUiImages = {
  './images/hero-image.svg': genHero,
  './images/architecture-flow.svg': genArch,
  './images/data-transformation.svg': genTransform,
  './images/tech-stack.svg': genStack,
}

// ── Notification Blog ──
import notifMd from './notification/index.md'
import notifImg1 from './notification/images/svg1-hero.svg'
import notifImg2 from './notification/images/svg2-pipeline.svg'
import notifImg3 from './notification/images/svg3-daily-stats.svg'
import notifImg4 from './notification/images/svg4-personalization.svg'
import notifImg5 from './notification/images/svg5-peak-hour.svg'
import notifImg6 from './notification/images/svg6-cron-scheduler.svg'
import notifImg7 from './notification/images/svg7-workers.svg'
import notifImg8 from './notification/images/svg8-timeline.svg'
import notifImg9 from './notification/images/svg9-checklist.svg'

const notifImages = {
  './images/svg1-hero.svg': notifImg1,
  './images/svg2-pipeline.svg': notifImg2,
  './images/svg3-daily-stats.svg': notifImg3,
  './images/svg4-personalization.svg': notifImg4,
  './images/svg5-peak-hour.svg': notifImg5,
  './images/svg6-cron-scheduler.svg': notifImg6,
  './images/svg7-workers.svg': notifImg7,
  './images/svg8-timeline.svg': notifImg8,
  './images/svg9-checklist.svg': notifImg9,
}

// ── Performance Testing Blog ──
import perfMd from './performance_testing/index.md'
import perfCover from './performance_testing/images/cover.svg'
import perfAutocannon from './performance_testing/images/svg-autocannon.svg'
import perfCluster from './performance_testing/images/svg-cluster.svg'
import perfExpressFastify from './performance_testing/images/svg-express-vs-fastify.svg'
import perfSummary from './performance_testing/images/svg-performance-summary.svg'
import perfProcessThread from './performance_testing/images/svg-process-thread.svg'
import perfSingleThread from './performance_testing/images/svg-single-thread.svg'

const perfImages = {
  './images/cover.svg': perfCover,
  './images/svg-autocannon.svg': perfAutocannon,
  './images/svg-cluster.svg': perfCluster,
  './images/svg-express-vs-fastify.svg': perfExpressFastify,
  './images/svg-performance-summary.svg': perfSummary,
  './images/svg-process-thread.svg': perfProcessThread,
  './images/svg-single-thread.svg': perfSingleThread,
}

const blogs = [
  {
    markdownUrl: contextBeforeCodeMd,
    images: contextBeforeCodeImages,
    slug: 'context-before-code',
    title:
      'How I Use Cursor and AI Coding Agents to Ship Features That Actually Last in Production',
    date: '2026-10-05',
    tags: ['AI', 'Cursor', 'Engineering', 'Agents', 'Workflow'],
    description:
      'I use Cursor almost every day. The hard part is not generating code. It is giving the agent enough context, constraints, and a plan so the feature still makes sense after it reaches production.',
    author: 'Aqib',
    readTime: '16 min read',
    thumbnail: contextBeforeCodeCover,
  },
  {
    markdownUrl: jitterBufferMd,
    images: jitterBufferImages,
    slug: 'voice-jitter-buffer',
    title: 'Voice Jitter Buffer: The Hardest Part of Building AI Voice Agents',
    date: '2026-10-02',
    tags: ['AI', 'Voice Agents', 'WebRTC', 'Real-Time', 'Networking', 'RTP'],
    description:
      'A deep dive into RTP packets, jitter buffers, and why sequence numbers and timestamps sit at the heart of real-time AI voice agents.',
    author: 'Aqib',
    readTime: '18 min read',
    thumbnail: jitterBufferCover,
  },
  {
    markdownUrl: agentConcurrencyMd,
    images: agentConcurrencyImages,
    slug: 'two-people-saved-the-same-agent',
    title: 'Two people saved the same agent. One change vanished.',
    date: '2026-09-29',
    tags: ['System Design', 'PostgreSQL', 'Concurrency', 'Backend', 'AI', 'Multi-tenant'],
    description:
      'Lost update and write skew look alike on an agent platform. How QuickStart AI protects draft edits with optimistic versioning and production with frozen snapshots, row locks, and a pointer live calls actually read.',
    author: 'Aqib',
    readTime: '17 min read',
    thumbnail: agentConcurrencyCover,
  },
  {
    markdownUrl: outboundMd,
    images: outboundImages,
    slug: 'outbound-services-resilience',
    title: 'We Stopped Installing LLM SDKs in Every Microservice',
    date: '2026-09-28',
    tags: ['AI', 'System Design', 'Backend', 'Resilience', 'Multi-tenant'],
    description:
      'How we built QuickStart AI so model calls and paid web APIs go through two internal services, with one policy for keys, retries, streams, and cost.',
    author: 'Aqib',
    readTime: '18 min read',
    thumbnail: outboundCover,
  },
  {
    markdownUrl: trojanMd,
    images: trojanImages,
    slug: 'trojan-horse-inside',
    title: 'The Gate Looks Strong. The Inside Still Trusts Too Much.',
    date: '2026-09-24',
    tags: ['Security', 'System Design', 'Zero Trust', 'Backend'],
    description:
      'A staff-level look at systems that look safe at the edge and stay weak inside: flat trust, missing checks, blast radius, and what to change.',
    author: 'Aqib',
    readTime: '14 min read',
    thumbnail: trojanCover,
  },
  {
    markdownUrl: promptLoopMd,
    images: promptLoopImages,
    slug: 'prompt-to-loop-engineering',
    title:
      'From Prompt Engineering to Loop Engineering: How AI Agents Actually Get Work Done',
    date: '2026-07-14',
    tags: [
      'AI',
      'Agents',
      'Harness Engineering',
      'Loop Engineering',
      'Verification Engineering',
      'Prompt Engineering',
    ],
    description:
      'A complete journey from prompts to production loops: context, harness, loop engineering, Andrew Ng\'s three nested loops, verification skills, and the systems that turn AI into reliable workers.',
    author: 'Aqib',
    readTime: '28 min read',
    thumbnail: promptLoopCover,
  },
  {
    markdownUrl: twentyMd,
    images: twentyImages,
    slug: 'dynamic-schema-generation-twenty',
    title: "How Twenty Queries Tables That Don't Exist in the Codebase",
    date: '2026-07-01',
    tags: ['System Design', 'PostgreSQL', 'SaaS', 'Architecture', 'Open Source'],
    description:
      'A deep technical breakdown of how TwentyHQ builds dynamic schema generation — creating database tables at runtime, querying them without entity classes, and rendering UI with zero code deployments.',
    author: 'Aqib',
    readTime: '18 min read',
    thumbnail: twentyCover,
  },
  {
    markdownUrl: notifMd,
    images: notifImages,
    slug: 'ai-personalized-notifications',
    title: 'How to Build AI Based Personalized Notifications That Reach Users at the Right Time',
    date: '2026-03-04',
    tags: ['AI', 'Notifications', 'Personalization', 'Push Notifications'],
    description:
      'A step-by-step technical guide to building a notification system that personalizes content and delivers it when each user is most active.',
    author: 'Aqib',
    readTime: '15 min read',
    thumbnail: notifImg1,
  },
  {
    markdownUrl: perfMd,
    images: perfImages,
    slug: 'performance-testing',
    title: 'Performance Testing Node.js Applications',
    date: '2026-02-14',
    tags: ['Node.js', 'Performance', 'Clustering', 'Backend'],
    description:
      'Highlights from performance testing a Node.js app — from 10K to 86K requests per second using clustering and Fastify.',
    author: 'Aqib',
    readTime: '10 min read',
    thumbnail: perfCover,
  },
  {
    markdownUrl: genUiMd,
    images: genUiImages,
    slug: 'generative-ui',
    title: 'Generative UI: LLM-Powered Analytics Reports',
    date: '2026-02-14',
    tags: ['AI', 'Generative UI', 'LLM', 'Analytics'],
    description:
      'How I connected an LLM with PostgreSQL and Firebase Analytics to generate human-readable analytics reports using Generative AI.',
    author: 'Aqib',
    readTime: '5 min read',
    thumbnail: genHero,
  },
  {
    markdownUrl: mcpMd,
    images: mcpImages,
    slug: 'mcp-vs-a2a',
    title: 'MCP vs A2A',
    date: '2026-02-14',
    tags: ['AI', 'MCP', 'A2A', 'Agents'],
    description:
      'Understanding the differences between MCP and A2A protocols, and when to use each for AI agent communication.',
    author: 'Aqib',
    readTime: '8 min read',
    thumbnail: mcpCover,
  },
  {
    markdownUrl: webrtcMd,
    images: webrtcImages,
    slug: 'webrtc',
    title: 'WebRTC: Real-Time Communication on the Web',
    date: '2026-02-14',
    tags: ['WebRTC', 'Real-Time', 'JavaScript', 'Networking'],
    description:
      'A deep dive into WebRTC — how it works, signaling, STUN/TURN servers, and building peer-to-peer connections.',
    author: 'Aqib',
    readTime: '15 min read',
    thumbnail: img03,
  },
]

export default blogs
